import { format as formatCnpj } from '../modules/utils/CnpjUtils';
var Format = /** @class */ (function () {
    function Format() {
    }
    Format.cnpj = function (cnpj) {
        return formatCnpj(cnpj);
    };
    Format.cpf = function (cpf) {
        return cpf ? cpf === null || cpf === void 0 ? void 0 : cpf.replace(/(\d{3})?(\d{3})?(\d{3})?(\d{2})/, "$1.$2.$3-$4") : "";
    };
    Format.telefone = function (telefone) {
        if (!telefone) {
            return '';
        }
        var apenasNumeros = telefone.replace(/\D/g, '');
        return apenasNumeros.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    };
    Format.formatarMoeda = function (valor) {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(valor);
    };
    return Format;
}());
export { Format };
